import { getType } from "typesafe-actions";
import * as language from "./actions";
import { languageOptions } from "../../utils/languages";
export var initialState = {
  languageId: "",
  languageLabels: null
};
export var languageReducer = function languageReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(language.set):
      var id = action.payload;
      var options = languageOptions[action.payload];

      if (!options) {
        id = "en_US";
      }

      return {
        languageId: id,
        languageLabels: languageOptions[id]
      };

    case getType(language.clear):
      return initialState;

    default:
      return state;
  }
};